
const icons = {
    play: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
</svg>`,
    pause: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
</svg>`
}

class Timer extends HTMLElement {
    static observedAttributes = ["data-seconds", "data-estimated", "data-working-since"];

    /**
     * @type {SVGSVGElement}
     */
    icon = null;
    /**
     * @type {HTMLSpanElement}
     */
    timer = null;

    /**
     * @type {HTMLSpanElement}
     */
    estimated = null;

    animation = null;

    constructor() {
        super();
        this.timer = this.querySelector('[data-time]');
        this.icon = this.querySelector('[data-icon]');
    }

    connectedCallback() {
        this.addEventListener('click', async function(e) {
            switch (this.icon.dataset.action) {
            case 'pause':
                this.setIcon('play');
                try {
                    await window.timers.requestStopCurrentTimer()
                } catch {
                    this.setIcon('pause');
                }
                break;
            case 'play':
                this.setIcon('pause');
                try {
                    await window.timers.requestStartTimerFor(this.dataset.task);
                } catch {
                    this.setIcon('play');
                }
                break;
            }
        }.bind(this));
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
        case 'data-seconds':
            this.updateTimeText(newValue)
            break;
        case 'data-working-since':
            this.updateAnimation(newValue)
            break;
        }
    }

    updateTimeText(seconds) {
        const estimated = parseInt(this.dataset.estimated ?? 0);

        this.timer.textContent = this.formatSecondsToTime(seconds);

        if(estimated > 0) {
            this.timer.textContent += ' / ' + this.formatSecondsToTime(estimated);
            if(seconds > estimated) {
                this.timer.style.color = '#cf1e1e';
            } else {
                this.timer.style.removeProperty('color');
            }
        }
    }

    formatSecondsToTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainderSeconds = seconds % 60;
        if(minutes < 60) {
            return this.formatTimestring(0, minutes, remainderSeconds);
        }
        const hours = Math.floor(minutes / 60);
        const remainderMinutes = minutes % 60;
        return this.formatTimestring(hours, remainderMinutes, remainderSeconds);
    }

    /**
     *
     * @param {number} hours
     * @param {number} minutes
     * @param {number} seconds
     * @returns {string}
     */
    formatTimestring(hours, minutes, seconds) {
        return [hours, minutes, seconds]
            .map(part => part.toString().padStart(2, '0'))
            .join(':');
    }

    setIcon(icon) {
        this.icon.dataset.action = icon;
        this.icon.innerHTML = icons[icon];
    }

    updateAnimation(newValue) {
        if(this.parseWorkingSinceSeconds() !== null) {
            this.setIcon('pause');
            this.animateTimer();
        } else {
            this.setIcon('play');
            cancelAnimationFrame(this.animation);
            this.animation = null;
        }
    }

    animateTimer() {
        this.animation = requestAnimationFrame(function() {
            const seconds = this.parseWorkingSinceSeconds();
            if(!seconds) {
                return;
            }
            this.updateTimeText(seconds);
            this.animateTimer();
        }.bind(this))
    }

    parseWorkingSinceSeconds() {
        const workingSince = Date.parse(this.dataset.workingSince);
        if(Number.isNaN(workingSince)) {
            return null;
        }
        const ms = Date.now() - Date.parse(this.dataset.workingSince)

        const seconds = parseInt(this.dataset.seconds);
        if(Number.isNaN(seconds)) {
            return null;
        }

        return seconds + Math.floor(ms / 1000);
    }
}

customElements.define('task-timer', Timer);
